import owd from 'owd/owd';

export default class ScrollTo extends owd.Module {
    constructor(app) {
        super(app);

        this.bind();
    }

    bind() {
        this.app.dom.$body.on('click', 'a[href^="#"]', function (e) {
            e.preventDefault();

            // let offset = $('[data-header]').outerHeight();

            $('html,body').animate({
                scrollTop: $($(this).attr('href')).offset().top
            }, 800, 'easeOutQuint');
        })
    }
}
